var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticStyle:{"min-height":"600px"}},[_c('Tabs',{attrs:{"type":"card","closable":""},on:{"on-tab-remove":_vm.tabRemove}},[_c('TabPane',{attrs:{"closable":false,"label":"年份统计"}},[_c('Years')],1),_c('TabPane',{attrs:{"closable":false,"label":"本年统计"}},[_c('year')],1),_c('TabPane',{attrs:{"closable":false,"label":"本月统计"}},[_c('month')],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f4fe0de","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/report/dialysisStatistics/index.vue
// module id = null
// module chunks = 